import { Queue, RunCode } from "../main";

// Groups queues with the same test and run_code
export interface GroupedQueue {
  id: string;
  run_code: RunCode;
  tags: string[] | null;
}

export function groupQueue(queue: Queue[], on: "threat" | "test") {
  const groupingsByTags: Record<string, GroupedQueue> = {};

  for (const q of queue) {
    const id = q[on];
    if (!id) {
      continue;
    }

    const key = id + q.run_code + (q.tag ? "tagged" : "untagged");
    const existing = groupingsByTags[key];

    if (existing) {
      if (q.tag) {
        if (!existing.tags) {
          existing.tags = [];
        }
        if (!existing.tags.includes(q.tag)) {
          existing.tags.push(q.tag);
        }
      }
    } else {
      groupingsByTags[key] = {
        id,
        run_code: q.run_code,
        tags: q.tag ? [q.tag] : null,
      };
    }
  }

  return Object.values(groupingsByTags);
}
